import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  id: z.string().min(1),
  fileName: z.string().optional(),
  content: z.string().optional(),
  language: z.string().optional(),
});

export type InputType = z.infer<typeof schema>;

export type FileMutationResult = {
  id: string;
  sessionId: string;
  fileName: string;
  filePath: string | null;
  language: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OutputType = {
  file: FileMutationResult;
};

export const updateFile = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/files/update`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
